import type { HbBidderConfig } from '../types'

export const LOOPME: HbBidderConfig = {
    bidder: 'loopme',
    params: {
        publisherId: '21212',
    },
}
